
import axios from '@/axios.js'
import url from '@/url.js'

export default {
  getGeoForward ({ }, payload) {
    return new Promise((resolve, reject) => { 
      const conn = {
        method: 'get',
        url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${payload.alamat},%20Kecamatan%20${payload.kecamatan},%20Kota%20${payload.kota},%20Provinsi%20${payload.provinsi},%20${payload.kodePos}.json`,
        params: {
          "language":"id",
          "access_token" : "pk.eyJ1IjoiYWxpbWFuZmF1emkiLCJhIjoiY2t5ZXpwYmtiMTd5cTMxcGk1MDkxeGI0biJ9.l_JDq1WsHFZ30AMuPQpg1g"
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  getGeoReverse ({ }, payload) {
    return new Promise((resolve, reject) => { 
      const conn = {
        method: 'get',
        url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${payload.longitude},${payload.latitude}.json`,
        params: {
          "language":"id",
          "access_token" : "pk.eyJ1IjoiYWxpbWFuZmF1emkiLCJhIjoiY2t5ZXpwYmtiMTd5cTMxcGk1MDkxeGI0biJ9.l_JDq1WsHFZ30AMuPQpg1g"
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  }  
}
